(() => {
  'use strict';

  const ROOT_CLASS = 'nav-icons-rolling';
  if (!document.documentElement.classList.contains(ROOT_CLASS)) return;

  const SELECTOR = '[data-magnetic], .roll-fx-js, [data-magnetic-group] .social-media__item';

  const buildRoll = (container) => {
    if (!container || container.querySelector(':scope > .icon-fx--rolling')) return;

    const rolled = [...container.childNodes];
    const hasContent = rolled.some(
      (node) => node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim())
    );
    if (!hasContent) return;

    const wrap = document.createElement('span');
    wrap.className = 'icon-fx icon-fx--rolling';

    const roll = document.createElement('span');
    roll.className = 'icon-fx__roll';

    const itemA = document.createElement('span');
    itemA.className = 'icon-fx__roll-item';

    const itemB = document.createElement('span');
    itemB.className = 'icon-fx__roll-item';
    itemB.setAttribute('aria-hidden', 'true');

    container.insertBefore(wrap, rolled[0]);
    itemA.append(...rolled);
    itemB.innerHTML = itemA.innerHTML;
    roll.append(itemA, itemB);
    wrap.append(roll);
  };
  
  const INNER_TARGET = '.search-link, .social-media__link, [slot="signed-out-avatar"]';

  const wrapTarget = (el) => buildRoll(el.querySelector(INNER_TARGET) ?? el);

  const init = (root = document) => root.querySelectorAll(SELECTOR).forEach(wrapTarget);

  init();

  const cartObserver = new MutationObserver((records) =>
    records.forEach(({ target }) => buildRoll(target))
  );
  document
    .querySelectorAll('[data-magnetic][id^="cart-icon-bubble-"]')
    .forEach((cart) => cartObserver.observe(cart, { childList: true }));

  document.addEventListener('shopify:section:load', ({ target }) => init(target));
})();
